import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { DOUBLE_PATTERN } from "../../../@auth/components/constants";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Customer } from "../../../models/customer.model";
import { Loan, LoanPaymentDetail } from "../../../models/loan.model";
import { Person } from "../../../models/person.model";
import { Catalog, Product } from "../../../models/product.model";

import Shop from "../../../models/shop.model";
import { CustomerService } from "../../../services/customer.service";
import { LoanService } from "../../../services/loan.service";
import { ProductService } from "../../../services/product.service";
import { DialogCustomerComponent } from "../../dialog-customer/dialog-customer.component";
import { DialogLinkCatalogComponent } from "../../dialog-link-catalog/dialog-link-catalog.component";
import { DialogLinkObjectComponent } from "../../dialog-link-object/dialog-link-object.component";
import { DialogProductComponent } from "../../dialog-product/dialog-product.component";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogLinkProductComponent } from "../dialog-link-product/dialog-link-product.component";

@Component({
  selector: "ngx-dialog-loan",
  templateUrl: "dialog-loan.component.html",
  styleUrls: ["dialog-loan.component.scss"],
})
export class DialogLoanComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() menu: string = "info"; //info / detail
  @Input() header: string;
  @Input() shopId?: string;
  @Input() shop?: Shop;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() loan?: Loan;
  @Input() mode: string; //new/edit
  @Input() groupLoans?: Catalog[] = [];
  @Input() units?: Catalog[] = [];
  @Input() groups?: Catalog[] = [];
  @Input() categories?: Catalog[] = [];
  @Input() suppliers?: Catalog[] = [];
  @Input() producers?: Catalog[] = [];
  @Input() origins?: Catalog[] = [];
  @Input() sizes?: Catalog[] = [];
  @Input() colors?: Catalog[] = [];

  loading = false;
  submitted = false;

  diaForm: FormGroup;
  edited = false;

  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  errMessagesDetail: string = "";
  errMessages: string = "";
  paymentDetail: LoanPaymentDetail = new LoanPaymentDetail();
  loanPaymentDetails: LoanPaymentDetail[] = [];

  loanReminds: LoanPaymentDetail[] = [];
  bk_remindDate: Date = new Date();

  constructor(
    protected ref: NbDialogRef<DialogLoanComponent>,
    private userService: UserService,
    private loanService: LoanService,
    public customerService: CustomerService,
    private productService: ProductService,
    private dialogService: NbDialogService,
    private fb: FormBuilder,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId;
          this.user = user;
        } else {
          this.uid = "anonymous";
        }
      });

    const noteValidators = [Validators.minLength(1), Validators.required];
    const amountValidators = [
      Validators.pattern(DOUBLE_PATTERN),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      // note: ["", noteValidators],
      // amount: ["", amountValidators],
      note: [],
      amount: [],
      remindAmount: [],
      issueDate: [],
      remindType: [],
      remindPaidNumber: [],
    });

    this.paymentDetail.issueDate = new Date();
    this.paymentDetail.isPaid = false;
    this.paymentDetail.paymentDate = new Date();
    this.paymentDetail.amount = 0;
    this.paymentDetail.comment = "";

    console.log("DialogLoanComponent/ngOnInit/loan:", this.loan);

    if (this.mode === "edit" && this.loan) {
      this.bk_remindDate = _.clone(this.loan.remindDate);
      this.loan.remindType = this.loan.remindType
        ? this.loan.remindType
        : "month";
      this.loan.remindPaidNumber = this.loan.remindPaidNumber
        ? this.loan.remindPaidNumber
        : 1;

      this.loan.issueDate = this.loan.issueDate
        ? moment(this.loan.issueDate).toDate()
        : new Date();
      this.loan.customer.cardIdDate = this.loan.customer?.cardIdDate
        ? moment(this.loan.customer.cardIdDate).toDate()
        : new Date();

      if (!this.loan.isClosed) {
        this.loan.remindDate = this.loanService.calculateRemindDate(this.loan);

        if (moment(this.loan.remindDate).isAfter(moment(this.bk_remindDate))) {
          this.loanService
            .updateRemindDate(this.loan)
            .then((data) => {
              console.log("🚀 updateRemindDate:", data);
            })
            .catch((err) => {
              console.log("🚀 ~ updateRemindDate/err:", err);
            });
        }
      }

      this.getLoanReminds();

      this.loanPaymentDetails = _.clone(this.loan.loanPaymentDetails);
      this.loanPaymentDetails = _.sortBy(this.loanPaymentDetails, [
        "issueDate",
      ]);
    } else {
      this.loan.note = "";
      this.loan.issueDate = new Date();
      this.loan.detailAmount = 0;
      this.loan.remindType = "month";
      this.loan.remindPaidNumber = 1;
      this.loan.customer = new Customer();
      this.loan.customerId = "";
      this.loan.customerName = "";

      this.loan.product = new Product();
      this.loan.productId = "";
      this.loan.productName = "";
      this.removeCatalog("");
    }

    this.diaForm.patchValue({
      note: this.loan.note,
      amount: this.loan.detailAmount.toString(),
      issueDate: this.loan.issueDate,
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initNewData() {
    this.mode = "new";
    let newProd = new Loan();
    newProd.shopId = this.loan.shopId;
    this.loan = newProd;
    this.loan.isPrint = false;
  }

  cancel() {
    this.ref.close();
  }

  selectMenu(value) {
    this.menu = value;
  }

  addPaymentDetail() {
    const item = _.clone(this.paymentDetail);
    if (this.loanPaymentDetails && this.loanPaymentDetails.length > 0) {
      this.loanPaymentDetails.push(item);
    } else {
      this.loanPaymentDetails = [item];
    }

    this.paymentDetail.issueDate = new Date();
    this.paymentDetail.isPaid = false;
    this.paymentDetail.paymentDate = new Date();
    this.paymentDetail.amount = 0;
    this.paymentDetail.comment = "";
    this.sumTotalPaidAmount();
  }

  removePaymentDetail(index) {
    this.loanPaymentDetails.splice(index, 1);
    this.sumTotalPaidAmount();
  }

  sumTotalPaidAmount() {
    this.loan.totalPaidAmount =
      this.loanPaymentDetails.length == 0
        ? 0
        : _.sumBy(this.loanPaymentDetails, function (o) {
            const amount = o.amount ? parseFloat(o.amount.toString()) : 0;
            return amount;
          });
  }

  datetimeChange(value, index, mode) {
    switch (mode) {
      case "issueDate":
        this.loanPaymentDetails[index].issueDate = value;
        break;
      case "paymentDate":
        this.loanPaymentDetails[index].paymentDate = value;
        break;
      default:
        break;
    }
  }

  submit() {
    this.errMessages = "";

    if (!this.loan.isClosed) {
      this.loan.remindDate = this.loanService.calculateRemindDate(this.loan);
    }

    this.loanPaymentDetails = _.sortBy(this.loanPaymentDetails, ["issueDate"]);
    this.loan.loanPaymentDetails = this.loanPaymentDetails
      ? _.clone(this.loanPaymentDetails)
      : [];

    this.loan.groupId = this.loan.groupId ? this.loan.groupId : "";
    this.loan.groupName = this.loan.groupId
      ? _.find(this.groupLoans, {
          id: this.loan.groupId,
        })?.title
      : "";

    this.loan.customerId = this.loan.customerId ? this.loan.customerId : "";
    this.loan.customerName = this.loan.customer
      ? this.loan.customer.fullName
      : "";

    this.loan.productId = this.loan.productId ? this.loan.productId : "";
    this.loan.productName = this.loan.product ? this.loan.product.title : "";

    this.loan.product.categoryId = this.loan.product.categoryId
      ? this.loan.product.categoryId
      : "";
    this.loan.product.categoryName = _.find(this.categories, {
      id: this.loan.product.categoryId,
    })?.title;
    this.loan.product.colorId = this.loan.product.colorId
      ? this.loan.product.colorId
      : "";
    this.loan.product.colorName = _.find(this.colors, {
      id: this.loan.product.colorId,
    })?.title;

    this.loan.detailAmount = this.diaForm.value.amount
      ? parseFloat(this.diaForm.value.amount)
      : 0;

    this.loan.totalPaidAmount =
      this.loanPaymentDetails.length == 0
        ? 0
        : _.sumBy(this.loanPaymentDetails, function (o) {
            const amount = o.amount ? parseFloat(o.amount.toString()) : 0;
            return amount;
          });

    if (!this.loan.customerName || this.loan.customerName === "") {
      this.errMessages += "\nTên khách hàng bắt buộc nhập";
    }
    if (!this.loan.productName || this.loan.productName === "") {
      this.errMessages += "\nTên hàng bắt buộc nhập";
    }

    if (this.errMessages.length == 0) {
      if (this.mode == "edit") {
        this.edit(this.loan);
      } else {
        this.create(this.loan);
      }
    }
  }

  //Control events
  //customer
  openCustomers() {
    this.dialogService
      .open(DialogLinkObjectComponent, {
        context: {
          header: `Xin vui lòng chọn`,
          shopId: this.shopId,
          linkObjectId: this.loan.customerId,
          objectType: "customer",
          objects: this.customerService.customers,
          allowCreate: false,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loan.customerId = value.id;
          this.loan.customerName = value.fullName;
          this.loan.customer = value
            ? value
            : value.id
            ? _.find(this.customerService.customers, {
                id: value.id,
              })
            : new Customer();
        }
      });
  }

  editCustomer() {
    let lecBk = _.find(this.customerService.customers, {
      id: this.loan.customerId,
    });

    this.dialogService
      .open(DialogCustomerComponent, {
        context: {
          header: "Cập nhật khách hàng",
          mode: "edit",
          shopId: this.shopId,
          user: this.user,
          customer: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          if (value.isDeleted) {
            this.loan.customerId = "";
            this.loan.customer = new Customer();
          } else {
            this.loan.customer = value;
          }
        }
      });
  }

  createCustomer() {
    this.loading = true;
    this.submitted = true;

    this.customerService
      .create(this.loan.customer)
      .then((data) => {
        console.log("🚀DialogLoanComponent/createCustomer:", data);
        this.loading = false;
        this.submitted = false;
        this.loan.customerId = data.id;

        this.loanService
          .saveCustomerId(this.loan.shopId, this.loan.id, this.loan.customerId)
          .then((data) => {})
          .catch((err) => {});
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  onNewCustomer() {
    this.loan.customerId = "";
    this.loan.customer = new Customer();
  }

  //product
  openProducts() {
    this.dialogService
      .open(DialogLinkProductComponent, {
        context: {
          header: `Xin vui lòng chọn`,
          shopId: this.shopId,
        },
      })
      .onClose.subscribe((value) => {
        if (value === "new") {
          this.onNewProduct();
        } else if (value) {
          this.loan.productId = value.id;
          this.loan.productName = value.title;
          this.loan.product = value
            ? value
            : value.id
            ? _.find(this.productService.products, {
                id: value.id,
              })
            : new Product();
        }
      });
  }

  onNewProduct() {
    this.loan.productId = "";
    this.loan.productName = "";
    this.loan.product = new Product();
    this.removeCatalog("");
  }

  createProduct() {
    this.loan.product.categoryId = this.loan.product.categoryId
      ? this.loan.product.categoryId
      : "";
    this.loan.product.categoryName = _.find(this.categories, {
      id: this.loan.product.categoryId,
    })?.title;
    this.loan.product.colorId = this.loan.product.colorId
      ? this.loan.product.colorId
      : "";
    this.loan.product.colorName = _.find(this.colors, {
      id: this.loan.product.colorId,
    })?.title;

    this.loading = true;
    this.submitted = true;

    this.productService
      .create(this.loan.product)
      .then((data) => {
        console.log("🚀DialogLoanComponent/createProduct:", data);
        this.loan.productId = data.id;

        this.loading = false;
        this.submitted = false;
        this.loanService
          .saveProductId(this.loan.shopId, this.loan.id, this.loan.productId)
          .then((data) => {})
          .catch((err) => {});
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  editProduct() {
    let lecBk = _.find(this.productService.products, {
      id: this.loan.productId,
    });
    this.dialogService
      .open(DialogProductComponent, {
        context: {
          header: "Cập nhật sản phẩm",
          user: this.user,
          mode: "edit",
          product: lecBk,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          if (value.isDeleted) {
            this.loan.productId = "";
            this.loan.product = new Customer();
          } else {
            this.loan.product = value;
          }
        }
      });
  }

  //catalog
  openCatalog(cat) {
    let catId = "";
    let catalogs;
    let header = "";
    switch (cat) {
      case "units":
        catId = this.loan.product.unitId;
        catalogs = this.units;
        header = "Đơn vị tính";
        break;
      case "groups":
        catId = this.loan.product.groupId = "";
        catalogs = this.groups;
        header = "Ngành hàng";
        break;
      case "categories":
        catId = this.loan.product.categoryId = "";
        catalogs = this.categories;
        header = "Loại hàng";
        break;
      case "suppliers":
        catId = this.loan.product.supplierId = "";
        catalogs = this.suppliers;
        header = "Nhà cung cấp";
        break;
      case "producers":
        catId = this.loan.product.producerId = "";
        catalogs = this.producers;
        header = "Nhà sản xuất";
        break;
      case "origins":
        catId = this.loan.product.originId = "";
        catalogs = this.origins;
        header = "Xuất xứ";
        break;
      case "sizes":
        catId = this.loan.product.sizeId = "";
        catalogs = this.sizes;
        header = "Kích thước";
        break;
      case "colors":
        catId = this.loan.product.colorId = "";
        catalogs = this.colors;
        header = "Màu sắc";
        break;
      case "groupLoans":
        catId = this.loan.groupId = "";
        catalogs = this.groupLoans;
        header = "Nhóm cầm đồ";
        break;
      default:
        break;
    }

    this.dialogService
      .open(DialogLinkCatalogComponent, {
        context: {
          header: `Xin vui lòng chọn ${header}.`,
          mode: cat,
          shopId: this.loan.product.shopId,
          linkCatalogId: catId,
          catalogs: catalogs,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          switch (cat) {
            case "units":
              this.loan.product.unitId = value.id;
              this.loan.product.unitName = value.id !== "" ? value.title : null;
              break;
            case "groups":
              this.loan.product.groupId = value.id;
              this.loan.product.groupName =
                value.id !== "" ? value.title : null;
              break;
            case "categories":
              this.loan.product.categoryId = value.id;
              this.loan.product.categoryName =
                value.id !== "" ? value.title : null;
              break;
            case "suppliers":
              this.loan.product.supplierId = value.id;
              this.loan.product.supplierName =
                value.id !== "" ? value.title : null;
              break;
            case "producers":
              this.loan.product.producerId = value.id;
              this.loan.product.producerName =
                value.id !== "" ? value.title : null;
              break;
            case "origins":
              this.loan.product.originId = value.id;
              this.loan.product.originName =
                value.id !== "" ? value.title : null;
              break;
            case "sizes":
              this.loan.product.sizeId = value.id;
              this.loan.product.sizeName = value.id !== "" ? value.title : null;
              break;
            case "colors":
              this.loan.product.colorId = value.id;
              this.loan.product.colorName =
                value.id !== "" ? value.title : null;
              break;
            case "groupLoans":
              this.loan.groupId = value.id;
              this.loan.groupName = value.id !== "" ? value.title : null;
              break;
            default:
              break;
          }
        }
      });
  }

  removeCatalog(cat) {
    switch (cat) {
      case "units":
        this.loan.product.unitId = "";
        break;
      case "groups":
        this.loan.product.groupId = "";
        break;
      case "categories":
        this.loan.product.categoryId = "";
        break;
      case "suppliers":
        this.loan.product.supplierId = "";
        break;
      case "producers":
        this.loan.product.producerId = "";
        break;
      case "origins":
        this.loan.product.originId = "";
        break;
      case "sizes":
        this.loan.product.sizeId = "";
        break;
      case "colors":
        this.loan.product.colorId = "";
        break;
      case "groupLoans":
        this.loan.groupId = "";
        this.loan.groupName = "";
        break;
      default:
        this.loan.product.unitId = "";
        this.loan.product.groupId = "";
        this.loan.product.categoryId = "";
        this.loan.product.supplierId = "";
        this.loan.product.producerId = "";
        this.loan.product.originId = "";
        this.loan.product.sizeId = "";
        this.loan.product.colorId = "";
        break;
    }
  }

  //loan
  private edit(item) {
    this.loading = true;
    this.submitted = true;

    this.loanService
      .update(item)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        if (this.loan.customerId === "") {
          this.createCustomer();
        }
        if (this.loan.productId === "") {
          this.createProduct();
        }

        //this.print();
        this.ref.close(this.loan);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  private create(item) {
    this.loading = true;
    this.submitted = true;

    this.loanService
      .create(item)
      .then((data) => {
        console.log("🚀 DialogLoanComponent/create:", data);
        this.loading = false;
        this.submitted = false;
        this.loan.id = data.id;

        this.createPaymentRemind();

        if (this.loan.customerId === "") {
          this.createCustomer();
        }
        if (this.loan.productId === "") {
          this.createProduct();
        }

        this.ref.close(this.loan);
      })
      .catch((err) => {
        console.log(
          "🚀 ~ file: dialog-loan.component.ts:543 ~ DialogLoanComponent ~ create ~ err:",
          err
        );

        this.loading = false;
        this.submitted = false;
      });
  }

  remove() {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;
          console.log(
            "🚀 ~ file: dialog-loan.component.ts:609 ~ DialogLoanComponent ~ .onClose.subscribe ~ this.loan.id:",
            this.loan.id
          );

          this.loanService
            .delete(this.loan.shopId, this.loan.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;

              this.loan.issueDate = new Date();
              this.loan.detailAmount = 0;
              this.loan.isDeleted = true;
              this.ref.close(this.loan);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  closed() {
    const title = this.loan.isClosed
      ? "Bạn có muốn mở khóa dữ liệu này?"
      : "Bạn có muốn khóa dữ liệu này";
    const description = this.loan.isClosed
      ? "Phần mềm sẽ thông báo đáo hạn thanh toán sau khi mở khóa dữ liệu"
      : "Phần mềm sẽ tắt thông báo đáo hạn thanh toán sau khi khóa dữ liệu";
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: title,
          description: description,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.loanService
            .closed(this.loan.shopId, this.loan.id, !this.loan.isClosed)
            .then((result) => {
              this.loading = false;
              this.submitted = false;

              this.loan.isClosed = !this.loan.isClosed;
              this.ref.close(this.loan);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  print() {
    this.loan.noPrint++;
    this.loading = true;
    this.submitted = true;

    // this.dialogService
    //   .open(DialogPrintLoanComponent, {
    //     context: {
    //       shopId: this.shopId,
    //       uid: this.uid,
    //       user: this.user,
    //       shop: this.shop,
    //       loan: this.loan,
    //       rePrint: false,
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((item) => {});
  }

  private async getLoanReminds() {
    const querySnapshot = await this.loanService.getLoanRemindsByLoan(
      this.shopId,
      this.loan.id
    );
    this.loanReminds = [];
    let existRemind: boolean = false;
    querySnapshot.forEach((doc) => {
      let remind = new LoanPaymentDetail();
      remind = doc.data();
      remind.id = doc.id;
      remind.issueDate = convertTimestamp(remind.issueDate);
      remind.paymentDate = convertTimestamp(remind.paymentDate);
      remind.updatedOn = convertTimestamp(remind.updatedOn);
      this.loanReminds.push(remind);

      if (
        moment(remind.issueDate).format("YYYY-MM-DD") ==
        moment(this.loan.remindDate).format("YYYY-MM-DD")
      ) {
        existRemind = true;
      }

      let loanPayment = _.clone(remind);
      delete loanPayment.loan;
      // const index = _.findIndex(this.loanPaymentDetails, {
      //   id: loanPayment.id,
      // });

      const index = _.findIndex(this.loanPaymentDetails, (item) => {
        return (
          item.id == loanPayment.id ||
          moment(remind.issueDate).format("YYYY-MM-DD") ==
            moment(item.issueDate).format("YYYY-MM-DD")
        );
      });
      if (index < 0) {
        this.loanPaymentDetails.push(loanPayment);
      }
    });

    console.log("getLoanReminds:", this.loanReminds);
    this.loanPaymentDetails = _.sortBy(this.loanPaymentDetails, ["issueDate"]);

    console.log("getLoanReminds/existRemind:", existRemind);

    if (!existRemind) {
      this.createPaymentRemind();
    }
  }

  private createPaymentRemind() {
    let loanPayment: LoanPaymentDetail = new LoanPaymentDetail();
    loanPayment.shopId = this.shopId;
    loanPayment.loan = JSON.parse(JSON.stringify(this.loan));
    loanPayment.loanId = this.loan.id;
    loanPayment.issueDate = this.loan.remindDate;
    loanPayment.amount = this.loan.remindAmount ? this.loan.remindAmount : 0;

    this.loanService
      .createPaymentRemind(loanPayment)
      .then((data) => {
        console.log("🚀 createPaymentRemind/create:", data);
        delete data.loan;
        this.loanPaymentDetails.push(data);
        this.loanPaymentDetails = _.sortBy(this.loanPaymentDetails, [
          "issueDate",
        ]);
      })
      .catch((err) => {
        console.log("🚀 ~ createPaymentRemind/err:", err);
      });
  }

  //---
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
